import React from "react";
import { Link } from "react-router-dom";

const scrollToBottom = () =>
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });

//

class Navbar extends React.Component {
  constructor() {
    super();
    this.state = {
      show: true,
      scrollPos: 0,
    };
  }
  //
  // ---------
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    // getBoundingClientRect , will get the size and the position
    // of the div, you need it for when the user will scroll: getBoundingClientRect().top > this.state.scrollPos,
    this.setState({
      scrollPos: document.body.getBoundingClientRect().top,
      show: document.body.getBoundingClientRect().top > this.state.scrollPos,
    });
  };

  //
  //
  //
  //
  render() {
    return (
      <React.Fragment>
        <header className={this.state.show ? "active" : "hidden"}>
          {/* ------------- */}
          <div className="logoSide">
            <h3>
              <Link className="logoMobile" to="/Home">
                VOLKANUVE
              </Link>
            </h3>
          </div>
          <nav className="pagesLinksSide">
            {/* --- */}

            <ul>
              <li>
                <Link className="navlinks" to="/Portfolio">
                  portfolio
                </Link>
              </li>
              <li>
                <Link className="navlinks" to="/About">
                  About
                </Link>
              </li>{" "}
              <li className="contactLinkNav" onClick={scrollToBottom}>
                Contact
              </li>
            </ul>
          </nav>
          {/* 
          
          
          end nav 
          
          
          
          */}

          {/* ----------- */}
          {/* <div className="contactLink" >
            <h4>Contact</h4>
          </div> */}
        </header>
      </React.Fragment>
    );
  }
}

export default Navbar;
